<template>
  <main>
    <container-small>
      <background-wrapper src="demo-header" ext="png">
        <div class="hero">
          <text-container size="sm">
            <h2 v-html="$t(`${$route.name}.header.title`)"/>
            <p v-html="$t(`${$route.name}.header.subTitle`)"/>
          </text-container>
        </div>
      </background-wrapper>
    </container-small>
    <background-wrapper src="policy-footer" ext="png">
      <container-small class="py-6">
        <div class="container">
          <div class="card py-2 px-3 py-sm-5 px-sm-6">
            <div class="header text-center mb-4">
              <h1>Let's start the conversation</h1>
              <p class="h-sub">Please provide us with a brief introduction to your organization by filling out the form below. We look forward to learning about your ideas for a partnership. The more you can share, the better we can prepare for our first discussion.</p>
            </div>
            <template v-if="thankYou">
              <h3 class="text-center">Thank you for your submission!</h3>
            </template>
            <template v-else>
              <div class="partner-form">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="firstName">First Name</label>
                  <input v-model="form.firstName" type="text" class="form-control" id="firstName" name="firstName" placeholder="First Name" value="">
                  <div v-if="errors.firstName" class="error">The field is required</div>
                </div>
                <div class="form-group col-md-6">
                  <label for="lastName">Last Name</label>
                  <input v-model="form.lastName" type="text" class="form-control" id="lastName" name="lastName" placeholder="Last Name" value="">
                  <div v-if="errors.lastName" class="error">The field is required</div>
                </div>
              </div>

              <div class="form-group">
                <label for="email">E-mail</label>
                <input v-model="form.email" type="email" class="form-control" id="email" name="email" placeholder="E-mail" value="">
                <div v-if="errors.email" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="phone">Phone Number</label>
                <input v-model="form.phone" type="tel" class="form-control" id="phone" name="phone" placeholder="Phone Number" value="">
                <div v-if="errors.phone" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="jobTitle">Job Title</label>
                <input v-model="form.jobTitle" type="text" class="form-control" id="jobTitle" name="jobTitle" placeholder="Job Title" value="">
                <div v-if="errors.jobTitle" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="companyName">Company Name</label>
                <input v-model="form.companyName" type="text" class="form-control" id="companyName" name="companyName" placeholder="Company Name" value="">
                <div v-if="errors.companyName" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="mission">What is your mission and core services or activities in the marketplace?</label>
                <textarea v-model="form.mission" id="mission" class="form-control" name="mission"></textarea>
                <div v-if="errors.mission" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="primaryMarkets">What are your primary markets (geographical, industries, types and sizes of organizations)?</label>
                <textarea v-model="form.market" id="primaryMarkets" class="form-control" name="primaryMarkets"></textarea>
                <div v-if="errors.market" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="targetAudience">Who is your target audience in more detail: for example, what are their titles and responsibilities?</label>
                <textarea v-model="form.audience" id="targetAudience" class="form-control" name="targetAudience"></textarea>
                <div v-if="errors.audience" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="locations">How many locations do you operate and where are they located?</label>
                <textarea v-model="form.locations" id="locations" class="form-control" name="locations"></textarea>
                <div v-if="errors.locations" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="companySize">What is the size of your organization? Can you share a range of how many customers or members you have? What is the reach of your communications? How many employees and volunteers do you have?</label>
                <textarea v-model="form.size" id="companySize" class="form-control" name="companySize"></textarea>
                <div v-if="errors.size" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label for="socialMedia">Please list your social media accounts and web addresses.</label>
                <textarea v-model="form.social" id="socialMedia" class="form-control" name="socialMedia"></textarea>
                <div v-if="errors.social" class="error">The field is required</div>
              </div>

              <div class="form-group">
                <label>Select some of your objectives for a potential partnership:</label>
                <div class="col-12">
                  <label class="checkbox-label" for="volume_based_pricing">
                    <input v-model="form.objectives.pricing" type="checkbox" name="objectives[]" id="volume_based_pricing" value="Volume based pricing for purchasing HRdownloads services to your members / clients">
                    <span>Volume-based pricing for purchasing HRdownloads services to provide to your members / clients</span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="checkbox-label" for="hr_expert_speaker">
                    <input v-model="form.objectives.speaker" type="checkbox" name="objectives[]" id="hr_expert_speaker" value="HR expert speaker appearances in you events">
                    <span>Expert HR speaker to appear at your event(s)</span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="checkbox-label" for="preferred_pricing">
                    <input v-model="form.objectives.members" type="checkbox" name="objectives[]" id="preferred_pricing" value="Preferred pricing that you can extend to your members / clients">
                    <span>Preferred pricing that you can extend to your members / clients</span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="checkbox-label" for="revenue_generating">
                    <input v-model="form.objectives.opportunities" type="checkbox" name="objectives[]" id="revenue_generating" value="Revenue generating opportunities through royalty based affiliate programs">
                    <span>Revenue generating opportunities through royalty based affiliate programs</span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="checkbox-label" for="hr_content">
                    <input v-model="form.objectives.media" type="checkbox" name="objectives[]" id="hr_content" value="HR content for your media vehicles">
                    <span>HR content for your media vehicles</span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="checkbox-label" for="other">
                    <input v-model="form.objectives.other" type="checkbox" name="objectives[]" id="other" value="other">
                    <span>Other? Please provide an overview:</span>
                  </label>
                  <div class="other-textarea-container">
                    <textarea v-model="form.otherDetails" id="other_details" class="form-control" name="otherDetails" aria-label="Other Details Text Area"></textarea>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="keyBenefits">What are the key benefits that your organization can offer? For example: backlinks, promotional space in your communication vehicles, content sharing, events, brand awareness, exposure to your members / customers?</label>
                <textarea v-model="form.benefits" id="keyBenefits" class="form-control" name="keyBenefits"></textarea>
                <div v-if="errors.benefits" class="error">The field is required</div>
              </div>

              <div class="submit-container text-center">
                <button class="btn btn-primary" @click="sendEmail">Submit</button>
              </div>
            </div>
            </template>
          </div>
        </div>
      </container-small>
    </background-wrapper>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BecomePartner',
  data () {
    return {
      thankYou: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        jobTitle: '',
        companyName: '',
        mission: '',
        market: '',
        audience: '',
        locations: '',
        size: '',
        social: '',
        objectives: {
          pricing: false,
          speaker: false,
          members: false,
          opportunities: false,
          media: false,
          other: false
        },
        otherDetails: '',
        benefits: ''
      },
      errors: {
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        jobTitle: false,
        companyName: false,
        mission: false,
        market: false,
        audience: false,
        locations: false,
        size: false,
        social: false,
        benefits: false
      }
    }
  },
  computed: {
    isFormValid () {
      return !Object.keys(this.errors).some(k => this.errors[k])
    },
    objectives () {
      return {
        pricing: this.form.objectives.pricing ? 'Volume-based pricing for purchasing HRdownloads services to provide to your members / clients \n' : '',
        speaker: this.form.objectives.speaker ? 'Expert HR speaker to appear at your event(s) \n' : '',
        members: this.form.objectives.members ? 'Preferred pricing that you can extend to your members / clients \n' : '',
        opportunities: this.form.objectives.opportunities ? 'Revenue generating opportunities through royalty based affiliate programs \n' : '',
        media: this.form.objectives.media ? 'HR content for your media vehicles \n' : '',
        other: this.form.objectives.other ? 'Other? Please provide an overview: \n' : ''
      }
    }
  },
  methods: {
    validEmail (email) {
      const re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },

    validate () {
      this.errors.firstName = this.form.firstName.length === 0
      this.errors.lastName = this.form.lastName.length === 0
      this.errors.phone = this.form.phone.length === 0
      this.errors.email = !this.validEmail(this.form.email)
      this.errors.jobTitle = this.form.jobTitle.length === 0
      this.errors.companyName = this.form.companyName.length === 0
      this.errors.mission = this.form.mission.length === 0
      this.errors.market = this.form.market.length === 0
      this.errors.audience = this.form.audience.length === 0
      this.errors.locations = this.form.locations.length === 0
      this.errors.size = this.form.size.length === 0
      this.errors.social = this.form.social.length === 0
      this.errors.benefits = this.form.benefits.length === 0
    },
    showThankYou () {
      this.thankYou = true
    },
    sendEmail () {
      this.validate()
      if (this.isFormValid) {
        const emailBody = `
          First Name - ${this.form.firstName} \n
          Last Name - ${this.form.lastName} \n
          E-mail - ${this.form.email} \n
          Phone Number - ${this.form.phone} \n
          Job Title - ${this.form.jobTitle} \n
          Company Name - ${this.form.companyName} \n
          What is your mission and core services or activities in the marketplace? - ${this.form.mission} \n
          What are your primary markets (geographical, industries, types and sizes of organizations)? - ${this.form.market} \n
          Who is your target audience in more detail: for example, what are their titles and responsibilities? - ${this.form.audience} \n
          How many locations do you operate and where are they located? - ${this.form.locations} \n
          What is the size of your organization? Can you share a range of how many customers or members you have? What is the reach of your communications? How many employees and volunteers do you have? - ${this.form.size} \n
          Please list your social media accounts and web addresses. - ${this.form.social} \n
          Objectives for a potential partnership: \n
          ${this.objectives.pricing}
          ${this.objectives.speaker}
          ${this.objectives.members}
          ${this.objectives.opportunities}
          ${this.objectives.media}
          ${this.objectives.other}
          ${this.form.otherDetails} \n
          What are the key benefits that your organization can offer? For example: backlinks, promotional space in your communication vehicles, content sharing, events, brand awareness, exposure to your members / customers? - ${this.form.benefits}
        `

        let data = new FormData()
        data.append('from', process.env['EMAIL_FROM'])
        data.append('to', process.env['PARTNERS_FORM_ADDRESS'])
        data.append('subject', 'HRDownloads.com Become a Partner form submission')
        data.append('body', emailBody)

        axios.post(`${process.env['CMS_DOMAIN']}/api/contact`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => {
            this.showThankYou()
          })
          .catch(err => console.log(err))
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.error
  color: red
.center
  text-align: center
.hero
  padding: 90px 0 200px
  +media-breakpoint-down(sm)
    padding: 60px 0 140px
  +media-breakpoint-down(xs)
    padding: 50px 0 100px

  .text-container
    text-align: left!important
    justify-items: start!important
    +media-breakpoint-down(sm)
      max-width: 400px
</style>



// WEBPACK FOOTER //
// src/components/becomePartner/BecomePartner.vue